"use strict";module.exports={Component:require("./Component"),inline:require("./inline"),mixin:{css:require("./inline")}};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-color/~/reactcss/lib/react-css.js
 ** module id = 2
 ** module chunks = 0
 **/